import type { CSSProperties } from 'react';
import clickIcon from '../../components/atomic/icons/click_icon.png';
import plaqueBackgroundImg from '../../pause_screen/plaque_frame/plaque_background.png';
import { containFitScale } from '../../../../infrastructure/runtime';
import { useAppFit } from '../../../hooks/useAppFit';
import {
  RUNNER_TUTORIAL_HINT_TEXT,
  type RunnerTutorialHint,
} from './gameplayConstants';
import './LevelTutorialHintOverlay.css';

type LevelTutorialHintOverlayProps = {
  hint: RunnerTutorialHint;
  /** Obstacle / booster: tap overlay to continue. Controls lets playfield receive the first hold. */
  capturePointer: boolean;
  onDismiss: () => void;
};

export function LevelTutorialHintOverlay({
  hint,
  capturePointer,
  onDismiss,
}: LevelTutorialHintOverlayProps) {
  const text = RUNNER_TUTORIAL_HINT_TEXT[hint];
  const fit = useAppFit();
  const contain = containFitScale(fit.scale);

  return (
    <div
      className={[
        'level-tutorial-hint-overlay',
        capturePointer
          ? 'level-tutorial-hint-overlay--capture'
          : 'level-tutorial-hint-overlay--ghost',
      ].join(' ')}
      role="dialog"
      aria-modal={capturePointer}
      aria-label={text}
    >
      {capturePointer ? (
        <button
          type="button"
          className="level-tutorial-hint-overlay__dismiss"
          aria-label="Продолжить"
          onClick={onDismiss}
        />
      ) : null}
      <div
        className="level-tutorial-hint-overlay__content"
        style={
          {
            '--fit-contain-inv-x': String(contain.invX),
            '--fit-contain-inv-y': String(contain.invY),
            '--fit-contain-uniform': String(contain.uniform),
          } as CSSProperties
        }
      >
        <div className="level-tutorial-hint-overlay__plaque">
          <img
            className="level-tutorial-hint-overlay__plaque-bg"
            src={plaqueBackgroundImg}
            alt=""
            draggable={false}
          />
          <p className="level-tutorial-hint-overlay__text">{text}</p>
        </div>
        {hint === 'controls' ? (
          <img
            className="level-tutorial-hint-overlay__click-icon"
            src={clickIcon}
            alt=""
            aria-hidden
            draggable={false}
          />
        ) : null}
      </div>
    </div>
  );
}
